import React from 'react';
import {connect} from 'react-redux';
import {fetchAnnotation} from './../actions';
import {FormattedMessage} from 'react-intl';
import diaHelper from '../../../helpers/diaHelper';
import {ANNOTATION_HAVE_TITLE} from "../../../constants/dia";
import stringHelper from "../../../helpers/stringHelper";

class AnnotationText extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.props.dispatch(fetchAnnotation(this.props.params.annotationId));
  }

  render() {
    let {annotation} = this.props;
    if (!annotation.item.attributes) {
      return <div/>;
    }
    let title = null;
    if (ANNOTATION_HAVE_TITLE.indexOf(annotation.item.attributes.annotation_type) >= 0) {
      let label = <span dangerouslySetInnerHTML={{__html: annotation.item.attributes.label}}/>;
      let labelLink = annotation.item.attributes.source_url ?
        <a href={annotation.item.attributes.source_url} target="_blank">{label}</a> : label;
      title = <h3>{labelLink}</h3>;
    }
    let type = <h2><FormattedMessage id={annotation.item.attributes.annotation_type}/></h2>;
    return (<div>
      {type}
      {title}
      <div dangerouslySetInnerHTML={{__html: diaHelper.formatAnnotationBody(annotation.item.attributes.body)}}/>
    </div>);
  }
}

function mapStateToProps(state) {
  const {annotation} = state;
  if (annotation.item && annotation.item.attributes && annotation.item.attributes.body) {
    annotation.item.attributes.body = stringHelper.optimizeHtml(annotation.item.attributes.body);
  }
  return {
    annotation
  };
}

AnnotationText.propTypes = {
  dispatch: React.PropTypes.func,
  params: React.PropTypes.object,
  annotation: React.PropTypes.object
};

export default connect(mapStateToProps)(AnnotationText);



/** WEBPACK FOOTER **
 ** ./src/modules/annotations/components/AnnotationText.js
 **/